import React from "react";
import { createComponent } from "@lit/react";
import { BeamPartnerLogos as _BeamPartnerLogos } from "./index";

export const BeamPartnerLogos = createComponent({
  tagName: "beam-partner-logos",
  elementClass: _BeamPartnerLogos,
  react: React,
  events: {},
});

export default BeamPartnerLogos; // default alias for use with async import utils like next/dynamic and react.lazy
